import React, { useCallback } from 'react';
import { getTranslation } from '@/hooks/useTranslation';
import useResponsiveness from '@/hooks/useResponsiveness';
import { useRouter } from 'expo-router';
import NavigationBarButtonContainer from '@/components/Navigation/NavigationBarButtonContainer';
import NavigationBarButton from '@/components/Navigation/NavigationBarButton';

const title = getTranslation('navigation.deck') || getTranslation('nav.routes.deck.title') || 'Deck';

/** Quick jump to the public recipe catalog from the deck header. */
const DeckRouteNavigationHeaderRight = React.memo(() => {
  const { isXS } = useResponsiveness();
  const router = useRouter();

  const onRecipes = useCallback((e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    router.push('/decks/recipes');
  }, [router]);

  const recipesLabel = getTranslation('nav.routes.deck.openRecipes') || 'Deck recipes';

  return (
    <NavigationBarButtonContainer rightPadding>
      <NavigationBarButton
        icon="layer-group"
        tooltip={getTranslation('nav.routes.deck.openRecipesTitle') || 'Browse deck recipe templates'}
        label={isXS ? undefined : recipesLabel}
        onPress={onRecipes}
      />
    </NavigationBarButtonContainer>
  );
});

DeckRouteNavigationHeaderRight.displayName = 'DeckRouteNavigationHeaderRight';

const DeckRouteNavigationOptions = {
  title,
  headerTitle: title,
  headerBackVisible: false,
  headerShown: true,
  headerRight: () => <DeckRouteNavigationHeaderRight />,
};

export default DeckRouteNavigationOptions;
